export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'Willkommen bei MyStorageX',
  'login.description': 'MyStorageX ist Ihr Cloud-Speicher-Assistent, der sicheren und bequemen Dateispeicher und -verwaltung bietet. Greifen Sie jederzeit und überall auf Ihre Dateien zu.',
  'login.email.placeholder': 'E-Mail oder Benutzername',
  'login.password.placeholder': 'Passwort',
  'login.button': 'Anmelden',
  'login.loading': 'Anmeldung läuft...',
  'login.divider': 'oder',
  'login.signup': 'Noch kein Konto?',
  'login.signup.link': 'Jetzt registrieren',
  'login.error.default': 'Anmeldung fehlgeschlagen, bitte versuchen Sie es später erneut',
  'login.success': 'Erfolgreich angemeldet',
  'login.forgotPassword': 'Passwort vergessen?',
  'login.forgotPassword.link': 'Hier zurücksetzen',
  'signup.page.title': 'Registrierung - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'Willkommen bei MyStorageX',
  'signup.description': 'Erstellen Sie Ihr Konto und starten Sie Ihre Cloud-Speicher-Reise',
  'signup.username.placeholder': 'Benutzername eingeben',
  'signup.email.placeholder': 'E-Mail eingeben',
  'signup.password.placeholder': 'Passwort eingeben',
  'signup.confirmPassword.placeholder': 'Passwort bestätigen',
  'signup.button': 'Registrieren',
  'signup.loading': 'Registrierung läuft...',
  'signup.login': 'Bereits ein Konto?',
  'signup.login.link': 'Anmelden',
  'signup.error.passwordMismatch': 'Passwörter stimmen nicht überein',
  'signup.error.default': 'Registrierung fehlgeschlagen, bitte versuchen Sie es später erneut',
  'signup.success': 'Erfolgreich registriert',
  'signup.username.rule.length': 'Benutzername muss zwischen 4 und 10 Zeichen lang sein',
  'signup.username.rule.format': 'Nur Buchstaben, Zahlen, Unterstriche und Bindestriche sind erlaubt',
  'signup.password.rule.length': 'Passwort muss zwischen 6 und 20 Zeichen lang sein',
  'signup.password.rule.lowercase': 'Muss Kleinbuchstaben enthalten',
  'signup.password.rule.uppercase': 'Muss Großbuchstaben enthalten',
  'signup.password.rule.number': 'Muss Zahlen enthalten',
  'signup.password.rule.special': 'Muss Sonderzeichen enthalten',
  'resetPassword.page.title': 'Passwort zurücksetzen - MyStorageX',
  'resetPassword.page.description': 'Setzen Sie Ihr MyStorageX-Kontopasswort zurück',
  'resetPassword.title': 'Passwort zurücksetzen',
  'resetPassword.email.placeholder': 'E-Mail-Adresse eingeben',
  'resetPassword.code.placeholder': 'Bestätigungscode eingeben',
  'resetPassword.password.placeholder': 'Neues Passwort eingeben',
  'resetPassword.button': 'Zurücksetzen',
  'resetPassword.button.loading': 'Wird zurückgesetzt...',
  'resetPassword.backToLogin': 'Zurück zum Login',
  'resetPassword.sendCode': 'Code anfordern',
  'resetPassword.sendCode.sending': 'Wird gesendet...',
  'resetPassword.sendCode.retry': 'In {seconds}s erneut versuchen',
  'resetPassword.error.emailRequired': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  'resetPassword.error.codeRequired': 'Bitte geben Sie den Bestätigungscode ein',
  'resetPassword.error.passwordRequired': 'Bitte geben Sie ein neues Passwort ein',
  'resetPassword.error.passwordLength': 'Das Passwort muss zwischen 6 und 20 Zeichen lang sein',
  'resetPassword.error.codeLength': 'Der Bestätigungscode muss 6 Ziffern enthalten',
  'resetPassword.success.codeSent': 'Bestätigungscode wurde an Ihre E-Mail gesendet',
  'resetPassword.success.reset': 'Passwort erfolgreich zurückgesetzt',
  'resetPassword.error.sendFailed': 'Fehler beim Senden des Bestätigungscodes, bitte versuchen Sie es später erneut',
  'resetPassword.error.resetFailed': 'Fehler beim Zurücksetzen des Passworts, bitte versuchen Sie es später erneut',
  'signup.verificationCode.placeholder': 'Bestätigungscode eingeben',
  'signup.verificationCode.send': 'Code abrufen',
  'signup.verificationCode.sending': 'Wird gesendet...',
  'signup.verificationCode.retry': 'In {seconds}s erneut versuchen',
  'signup.verificationCode.success': 'Bestätigungscode gesendet',
  'signup.verificationCode.error': 'Fehler beim Senden des Codes',
  'signup.verificationCode.required': 'Bitte Bestätigungscode eingeben',
  'signup.verificationCode.invalid': 'Ungültiges Verifizierungscode-Format',
  'signup.error.emailRequired': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
  'signup.announcement': 'Die Registrierungsfunktion wird heute gewartet!',
  'sidebar.allFiles': 'Alle Dateien',
  'sidebar.starred': 'Favoriten',
  'sidebar.folders': 'Ordner',
  'sidebar.trash': 'Papierkorb',
  'sidebar.decrypt': 'Entschlüsselungstool',
  'sidebar.feedback': 'Feedback',
  'sidebar.about': 'Über',
  'sidebar.productLog': 'Produktaktualisierungen',
  'filelist.column.name': 'Name',
  'filelist.column.size': 'Größe',
  'filelist.column.updateTime': 'Geändert',
  'filelist.column.recycletime': 'Gelöscht am',
  'filelist.column.actions': 'Aktionen',
  'filelist.total': 'Insgesamt {total} Elemente',
  'filelist.action.upload': 'Hochladen',
  'filelist.action.newFolder': 'Neuer Ordner',
  'filelist.action.refresh': 'Aktualisieren',
  'filelist.action.search': 'Dateien suchen',
  'filelist.action.batchDownload': 'Herunterladen',
  'filelist.action.batchDelete': 'Löschen',
  'filelist.action.download': 'Herunterladen',
  'filelist.action.preview': 'Vorschau',
  'filelist.action.rename': 'Umbenennen',
  'filelist.selected': '{count} ausgewählt',
  'page.cloudDrive.title': 'Mein Cloud-Laufwerk',
  'page.cloudDrive.description': 'MyStorageX Cloud-Laufwerk - Speichern und verwalten Sie Ihre Dateien sicher',
  'modal.fileUpload.title': 'Dateien hochladen',
  'modal.fileUpload.dragText': 'Dateien hierher ziehen oder klicken zum Hochladen',
  'modal.fileUpload.start': 'Upload starten',
  'modal.fileUpload.cancel': 'Abbrechen',
  'modal.fileUpload.clear': 'Liste leeren',
  'modal.fileUpload.encrypt': 'Ausgewählte verschlüsseln',
  'modal.fileUpload.addMore': 'Hinzufügen',
  'modal.fileUpload.remove': 'Entfernen',
  'modal.fileUpload.error.noSelection': 'Bitte wählen Sie Dateien zum Entfernen aus',
  'modal.fileUpload.error.noEncryption': 'Bitte wählen Sie Dateien zum Verschlüsseln aus',
  'modal.fileUpload.error.noClear': 'Keine Dateien zum Löschen',
  'modal.fileUpload.error.noStart': 'Keine Dateien zum Hochladen',
  'modal.fileUpload.error.noCancel': 'Kein laufender Upload zum Abbrechen',
  'modal.fileUpload.error.fileSize': 'Dateigröße überschreitet das Limit',
  'modal.fileUpload.error.fileType': 'Nicht unterstützter Dateityp',
  'modal.fileUpload.error.maxCount': 'Maximale Dateianzahl überschritten',
  'modal.fileUpload.duplicate.title': 'Datei existiert bereits',
  'modal.fileUpload.duplicate.skip': 'Überspringen',
  'modal.fileUpload.duplicate.replace': 'Ersetzen',
  'modal.fileUpload.duplicate.rename': 'Umbenennen',
  'modal.fileUpload.status.pending': 'Ausstehend',
  'modal.fileUpload.status.uploading': 'Wird hochgeladen',
  'modal.fileUpload.status.success': 'Abgeschlossen',
  'modal.fileUpload.status.error': 'Fehler',
  'modal.fileUpload.status.cancelled': 'Abgebrochen',
  'modal.fileUpload.status.duplicated': 'Dupliziert',
  'modal.fileUpload.table.filename': 'Dateiname',
  'modal.fileUpload.table.size': 'Größe',
  'modal.fileUpload.table.status': 'Status',
  'modal.fileUpload.table.progress': 'Fortschritt',
  'modal.fileUpload.table.actions': 'Aktionen',
  'modal.fileUpload.speed': 'Upload-Geschwindigkeit',
  'modal.fileUpload.remainingTime': 'Verbleibende Zeit',
  'modal.fileUpload.total.progress': 'Gesamtfortschritt',
  'modal.fileUpload.error.message': 'Upload fehlgeschlagen: {message}',
  'modal.fileUpload.confirm.clear': 'Möchten Sie die Upload-Liste leeren?',
  'modal.fileUpload.confirm.cancel': 'Möchten Sie den Upload abbrechen?',
  'modal.fileUpload.clear.mobile': 'Leeren',
  'modal.fileUpload.encrypt.mobile': 'Verschlüsseln',
  'modal.fileUpload.addMore.mobile': 'Hinzufügen',
  'productLog.title': 'Produktaktualisierungen',
  // Sicherheitsfunktionen
  'security.features.title': 'Sicherheitsfunktionen',
  'security.features.localDecryption.title': 'Lokale Entschlüsselung',
  'security.features.localDecryption.description': 'Alle Entschlüsselungsvorgänge werden lokal im Browser durchgeführt, Dateiinhalte und Passwörter verlassen nie Ihr Gerät',
  'security.features.militaryEncryption.title': 'Militärische Verschlüsselung',
  'security.features.militaryEncryption.description': 'Verwendet AES-256-CBC Verschlüsselungsalgorithmus, den sichersten symmetrischen Verschlüsselungsstandard gegen alle bekannten Angriffe',
  'security.features.privacyProtection.title': 'Datenschutz',
  'security.features.privacyProtection.description': 'Strenger Datenschutzmechanismus, keine Speicherung von Entschlüsselungspasswörtern, keine Aufzeichnung von Dateiinhalten',
  'security.features.smartDecryption.title': 'Smart-Chunk-Entschlüsselung',
  'security.features.smartDecryption.description': 'Smart-Chunk-Entschlüsselungstechnologie verbessert die Entschlüsselungsgeschwindigkeit bei reduziertem Speicherverbrauch',
  'security.features.learnMore': 'Mehr erfahren',
  'security.features.modal.title': 'Sicherheitsfunktionen Details',
  'security.features.modal.close': 'Schließen',
  // Sicherheitshinweise Modal
  'decrypt.security.modal.title': 'Sicherheitshinweis',
  'decrypt.security.modal.description': 'Alle Entschlüsselungsvorgänge werden lokal durchgeführt, Ihr Passwort und Dateiinhalt werden nicht an Server übertragen',
  'decrypt.security.modal.vip.title': 'Als VIP-Benutzer können Sie:',
  'decrypt.security.modal.vip.feature1': 'Dateien beliebiger Größe entschlüsseln',
  'decrypt.security.modal.vip.feature2': 'Smart-Chunk-Entschlüsselung für bessere Effizienz nutzen',
  'decrypt.security.modal.vip.feature3': 'Große Dateien im Batch entschlüsseln',
  'decrypt.security.modal.free.title': 'Wichtig: Der Entschlüsselungsprozess benötigt etwa das 3-fache der Dateigröße an Browser-Speicher.',
  'decrypt.security.modal.free.feature1': 'Kostenlose Nutzer sind auf 4GB pro Datei beschränkt',
  'decrypt.security.modal.free.feature2': 'Upgrade auf VIP für unbegrenzte Dateigröße',
  'decrypt.security.modal.free.feature3': 'Bei Browser-Abstürzen erwägen Sie ein Upgrade für Chunk-Entschlüsselung',
  // CBC-Verschlüsselungsdiagramm
  'security.diagram.plaintext.block1': 'Klartext Block 1',
  'security.diagram.plaintext.block2': 'Klartext Block 2',
  'security.diagram.ciphertext.block1': 'Chiffretext Block 1',
  'security.diagram.ciphertext.block2': 'Chiffretext Block 2',
  'security.diagram.key': 'Schlüssel',
  'security.diagram.aes.encryption': 'AES Verschlüsselung',
  'security.diagram.xor.operation': 'XOR Operation',
  'security.diagram.iv': 'Initialisierungsvektor',
  // Smart Chunk Decryption
  'security.features.chunk.title': 'Intelligente Block-Entschlüsselungstechnologie',
  'security.features.chunk.what': 'Was ist Intelligente Block-Entschlüsselung?',
  'security.features.chunk.description': 'Die intelligente Block-Entschlüsselung ist eine optimierte Technologie für große Dateien, die Dateien in mehrere Blöcke für parallele Verarbeitung aufteilt, mit folgenden Merkmalen:',
  'security.features.chunk.feature1.title': 'Dynamische Aufteilung',
  'security.features.chunk.feature1.desc': 'Passt die Blockgröße automatisch basierend auf Dateigröße und Systemspeicher an',
  'security.features.chunk.feature2.title': 'Parallele Verarbeitung',
  'security.features.chunk.feature2.desc': 'Mehrere Datenblöcke werden gleichzeitig entschlüsselt, nutzt Mehrkern-CPUs voll aus',
  'security.features.chunk.feature3.title': 'Speicheroptimierung',
  'security.features.chunk.feature3.desc': 'Steuert die Speichernutzung durch Streaming-Verarbeitung, um Überlauf zu verhindern',
  'security.features.chunk.feature4.title': 'Wiederaufnahme-Unterstützung',
  'security.features.chunk.feature4.desc': 'Unterstützt Fortsetzung nach Unterbrechung, verbessert die Fehlertoleranz',
  'security.features.chunk.how': 'Funktionsweise',
  'security.features.chunk.process': 'Der intelligente Block-Entschlüsselungsprozess umfasst folgende Schritte:',
  'security.features.chunk.step1': 'Dateianalyse: Berechnet optimale Blockgröße und -anzahl',
  'security.features.chunk.step2': 'Datenaufteilung: Teilt verschlüsselte Datei in gleich große Blöcke',
  'security.features.chunk.step3': 'Parallele Entschlüsselung: Mehrere Blöcke werden gleichzeitig entschlüsselt',
  'security.features.chunk.step4': 'Stream-Schreiben: Entschlüsselte Blöcke werden sequentiell geschrieben',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': 'Leistungsvorteile',
  'security.features.chunk.performance.intro': 'Im Vergleich zur traditionellen Entschlüsselung bietet die intelligente Block-Entschlüsselung signifikante Vorteile:',
  'security.features.chunk.performance.point1': 'Speichernutzung um bis zu 90% reduziert, nur 400MB für 4GB-Datei benötigt',
  'security.features.chunk.performance.point2': '3-5-mal schnellere Entschlüsselungsgeschwindigkeit, nutzt Mehrkern-CPUs',
  'security.features.chunk.performance.point3': 'Unterstützt Entschlüsselung großer Dateien (>4GB), nicht durch Browser-Speicher begrenzt',
  'security.features.chunk.performance.point4': 'Visueller Entschlüsselungsprozess mit genauem Fortschritt und Restzeit',
  'security.features.chunk.usage': 'Anwendungsfälle',
  'security.features.chunk.usage.intro': 'Die intelligente Block-Entschlüsselung ist besonders geeignet für folgende Szenarien:',
  'security.features.chunk.usage.point1': 'Entschlüsselung großer Dateien (z.B. Videos, Datenbank-Backups)',
  'security.features.chunk.usage.point2': 'Entschlüsselungsoperationen auf Geräten mit begrenztem Speicher',
  'security.features.chunk.usage.point3': 'Batch-Entschlüsselung, die parallele Verarbeitung erfordert',
  'security.features.chunk.usage.point4': 'Entschlüsselungsaufgaben, die Echtzeit-Feedback erfordern',
  'security.features.chunk.diagram': 'Diagramm des Block-Entschlüsselungsprozesses',
  'security.features.aes.security': 'Sicherheitseigenschaften',
  'security.features.aes.security.intro': 'AES-256-CBC bietet mehrere Sicherheitsgarantien:',
  'security.features.aes.security.point1': '256-Bit-Schlüssel bietet 2^256 mögliche Kombinationen, unmöglich durch Brute-Force zu knacken, selbst mit einem Supercomputer',
  'security.features.aes.security.point2': 'CBC-Modus stellt sicher, dass identische Klartextblöcke unterschiedliche verschlüsselte Blöcke erzeugen und erhöht die Verschlüsselungsrandomisierung',
  'security.features.aes.security.point3': 'Die Verwendung des Initialisierungsvektors (IV) stellt sicher, dass selbst mit demselben Schlüssel jede Verschlüsselung ein anderes Ergebnis liefert',
  'security.features.aes.security.point4': 'Wird weithin in militärischen, finanziellen und anderen Bereichen mit hohen Sicherheitsanforderungen eingesetzt',
  'security.features.aes.diagram': 'Dynamisches Diagramm des CBC-Modus-Verschlüsselungsprozesses',
  'security.features.aes.why': 'Warum AES-256-CBC?',
  'security.features.aes.why.intro': 'Wir haben AES-256-CBC aus folgenden Gründen als Verschlüsselungsstandard gewählt:',
  'security.features.aes.why.point1': 'Umfassend validierte Sicherheit, keine praktischen Angriffsmethoden bis heute',
  'security.features.aes.why.point2': 'Ausgezeichnete Leistung, schnelle Ver- und Entschlüsselung',
  'security.features.aes.why.point3': 'Hardware-Beschleunigungsunterstützung, AES-Befehlssatz in modernen Prozessoren integriert',
  'security.features.aes.why.point4': 'Breite Werkzeugunterstützung, ausgereifte Implementierungen in allen Programmiersprachen',
  'security.features.aes.what': 'Was ist AES-256-CBC?',
  'security.features.aes.description': 'AES-256-CBC ist eine Implementierung des Advanced Encryption Standard, wobei:',
  'security.features.aes.detail.1': 'Ein symmetrischer Verschlüsselungsalgorithmus, der 2001 vom US National Institute of Standards and Technology (NIST) etabliert wurde',
  'security.features.aes.detail.2': 'Verwendet eine 256-Bit-Schlüssellänge und bietet höchste Sicherheitsstufe',
  'security.features.aes.detail.3': 'Cipher Block Chaining (CBC) Modus bietet verbesserte Verschlüsselungssicherheit',
  'security.features.aes.how': 'Funktionsweise',
  'security.features.aes.process': 'Der AES-256-CBC Verschlüsselungsprozess umfasst folgende Schritte:',
  'security.features.aes.step1': 'Aufteilung der Klartextdaten in Blöcke fester Größe (128 Bit)',
  'security.features.aes.step2': 'Generierung eines zufälligen Initialisierungsvektors (IV)',
  'security.features.aes.step3': 'XOR-Operation zwischen vorherigem Chiffretext-Block und aktuellem Klartext-Block im CBC-Modus',
  'security.features.aes.step4': 'Verwendung des 256-Bit-Schlüssels zur AES-Verschlüsselung des XOR-Ergebnisses',
  'security.features.aes.example': 'Beispiel des Verschlüsselungsprozesses:',
  // FileList Section
  'decrypt.fileList.column.name': 'Dateiname',
  'decrypt.fileList.column.status': 'Status',
  'decrypt.fileList.column.actions': 'Aktionen',
  'decrypt.fileList.status.pending': 'Ausstehend',
  'decrypt.fileList.status.decrypting': 'Entschlüsseln',
  'decrypt.fileList.status.success': 'Abgeschlossen',
  'decrypt.fileList.status.error': 'Fehler',
  'decrypt.fileList.action.info': 'Information',
  'decrypt.fileList.empty': 'Keine Dateien zum Entschlüsseln',
  'common.unknown': 'Unbekannt',
  'common.speed': 'Geschwindigkeit',
  'common.timeSpent': 'Verstrichene Zeit',
  'common.remaining': 'Verbleibend',
  // Upload Section
  'decrypt.upload.dragText': 'Dateien hier klicken oder ziehen',
  'decrypt.upload.hint': 'Unterstützt Stapelhinzufügung von .encrypted Dateien, maximal {maxSize} pro Datei',
  'decrypt.upload.button.decrypt': 'Ausgewählte Dateien entschlüsseln',
  'decrypt.upload.button.clear': 'Liste leeren',
  'page.decrypt.title': 'Entschlüsselungswerkzeug',
  'page.decrypt.subtitle': 'Entschlüsseln Sie Ihre Dateien sicher und schnell',
  // File Info Modal
  'decrypt.fileInfo.modal.title': 'Dateiinformationen',
  'decrypt.fileInfo.modal.close': 'Schließen',
  'decrypt.fileInfo.name': 'Dateiname',
  'decrypt.fileInfo.size': 'Dateigröße',
  'decrypt.fileInfo.type': 'Dateityp',
  'decrypt.fileInfo.lastModified': 'Zuletzt geändert',
  'decrypt.fileInfo.status': 'Status',
  'decrypt.fileInfo.progress': 'Fortschritt',
  'decrypt.fileInfo.speed': 'Geschwindigkeit',
  'decrypt.fileInfo.timeRemaining': 'Verbleibende Zeit',
  'decrypt.fileInfo.timeSpent': 'Verstrichene Zeit',
  'decrypt.fileInfo.error': 'Fehlermeldung',
  'filelist.modal.rename.title': 'Umbenennen',
  'filelist.modal.rename.placeholder': 'Neuen Namen eingeben',
  'filelist.modal.rename.ok': 'OK',
  'filelist.modal.rename.cancel': 'Abbrechen',
  'sideMenu.storageInfo.title': 'Speicherplatz',
  'sideMenu.storageInfo.usage': 'Verwendet {used} / Gesamt {total}',
  'sideMenu.storageStats.title': 'Speicherstatistik',
  'sideMenu.storageStats.overview': 'Übersicht',
  'sideMenu.storageStats.totalFiles': 'Gesamtanzahl Dateien',
  'sideMenu.storageStats.totalSize': 'Gesamtgröße',
  'sideMenu.storageStats.fileTypes': 'Dateitypenverteilung',
  'sideMenu.storageStats.providers': 'Dienstanbieter',
  'common.default': 'Standard',
  'common.regionCode': 'Regionscode',
  'common.nodeType': 'Knotentyp',
  'common.storageUsed': 'Belegter Speicher',
  'common.storageAvailable': 'Verfügbarer Speicher',
  'common.storageLimit': 'Gesamtkapazität',
  'common.storageUsageDetail': 'Belegt {used} / Gesamt {total}',
  'common.defaultNode': 'Standardknoten',
  'common.confirm': 'Bestätigen',
  'common.cancel': 'Abbrechen',
  'common.latency': 'Latenz',
  'common.retry': 'Wiederholen',
  'cloudDrive.nodeSelect.title': 'Speicherknoten auswählen',
  'cloudDrive.nodeSelect.addNode': 'Speicherknoten hinzufügen',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'Löschung des Knotens bestätigen',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'Möchten Sie den Knoten "{nodeName}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
  'cloudDrive.nodeSelect.deleteSuccess': 'Knoten erfolgreich gelöscht',
  'cloudDrive.nodeSelect.deleteFailed': 'Fehler beim Löschen des Knotens',
  
  // Knoten erstellen
  'cloudDrive.nodeCreate.title': 'Speicherknoten hinzufügen',
  'cloudDrive.nodeCreate.selectProvider': 'Cloud-Anbieter auswählen',
  'cloudDrive.nodeCreate.nodeName': 'Knotenname',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'Leer lassen, um Standardnamen zu verwenden',
  'cloudDrive.nodeCreate.nameMaxLength': 'Knotenname darf 50 Zeichen nicht überschreiten',
  'cloudDrive.nodeCreate.noProviders': 'Keine Cloud-Anbieter verfügbar',
  'cloudDrive.nodeCreate.pingLatency': 'Latenz {value} ms',
  'cloudDrive.nodeCreate.pingTesting': 'Latenz wird getestet...',
  'cloudDrive.nodeCreate.pingFailed': 'Latenztest fehlgeschlagen',
  'cloudDrive.nodeCreate.pingUnavailable': 'Latenztest nicht verfügbar',
  'cloudDrive.nodeCreate.sortByLatency': 'Nach Latenz sortieren',
  'cloudDrive.nodeCreate.selectRegion': 'Region auswählen',
  'cloudDrive.nodeCreate.selectedRegion': 'Ausgewählte Region',
  'cloudDrive.nodeCreate.noRegions': 'Keine Regionen verfügbar',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'Bitte wählen Sie einen Cloud-Anbieter',
  'cloudDrive.nodeCreate.selectProviderRequired': 'Bitte wählen Sie zuerst einen Cloud-Anbieter',
  'cloudDrive.nodeCreate.selectRegionRequired': 'Bitte wählen Sie zuerst eine Region',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'Fehler beim Laden der Cloud-Anbieter-Liste',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'Fehler beim Laden der Regionsliste',
  'cloudDrive.nodeCreate.nodeType': 'Knotentyp',
  'cloudDrive.nodeCreate.nodeType.standard': 'Standard-Speicher',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'Niedrigfrequenz-Speicher',
  'cloudDrive.nodeCreate.nodeType.archive': 'Archiv-Speicher',
  'cloudDrive.nodeCreate.storageLimit': 'Speicherlimit',
  'cloudDrive.nodeCreate.storageLimitRequired': 'Bitte geben Sie das Speicherlimit ein',
  'cloudDrive.nodeCreate.storageLimitMin': 'Das Speicherlimit darf nicht kleiner als 1GB sein',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'Geben Sie das Speicherlimit ein (GB)',
  'cloudDrive.nodeCreate.success': 'Speicherknoten erfolgreich erstellt',
  'cloudDrive.nodeCreate.failed': 'Fehler beim Erstellen des Speicherknotens',
  
  // Knoten bearbeiten
  'cloudDrive.nodeEdit.title': 'Knoten bearbeiten',
  'cloudDrive.nodeEdit.name': 'Knotenname',
  'cloudDrive.nodeEdit.nameRequired': 'Bitte Knotennamen eingeben',
  'cloudDrive.nodeEdit.nameMaxLength': 'Knotenname darf 50 Zeichen nicht überschreiten'
}; 